/* eslint-disable */
import uiConfig from '@onereach/ui-config'
import localOverrides from 'localOverrides'
import runningProjects from 'runningProjects'

import config from '../env.json'


export default uiConfig(config, runningProjects, localOverrides);
